import { graphql } from 'gatsby'
import React from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnAuthor001 from '../../../components/molecules/columnAuthor001'
import ColumnDetailInner0018 from '../../../components/molecules/columnDetailInner0018'
import ColumnRelationCards0018 from '../../../components/molecules/columnRelationCards0018'
import UsefulFunctionLayout006 from '../../../components/molecules/usefulFunctionLayout006'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0018 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: 'フレックスタイム制とは？活用方法と留意点を解説！',
    },
  ]

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="フレックスタイム制はどんな制度？導入のメリットとポイント"
        description="フレックスタイム制は一定期間の総労働時間を定め、労働者がその範囲内で始業および終業時刻を選択できる制度です。企業や労働者にとって、幅広い働き方の一つです。"
        ogUrl="https://kintaicloud.jp/column/details/C0018/"
        ogType="article"
        ogTitle="フレックスタイム制はどんな制度？導入のメリットとポイント"
        ogDescription="フレックスタイム制は一定期間の総労働時間を定め、労働者がその範囲内で始業および終業時刻を選択できる制度です。企業や労働者にとって、幅広い働き方の一つです。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0018.jpg"
      />
      <ColumnDetailsBody>
        {/** 記事本体 */}
        <ColumnDetailInner0018 />
        {/** オーサ情報 */}
        <ColumnAuthor001 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout006 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** 関連記事 */}
        <ColumnRelationCards0018 />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0018

export const pageQuery = graphql`
  query C0018 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
